export default __webpack_public_path__ + "static/346-7c958400f387559ea48952b3a0942f1d.gif";